import { LogLevel } from '@signage-player/contracts';
export class DisplayPlayerManager {
    constructor(logger, playerManagerFactory) {
        this.logger = logger;
        this.playerManagerFactory = playerManagerFactory;
        this.playerManagers = new Map();
        this.onDestroyCallback = null;
    }
    async initializeForDisplay(displayId) {
        this.logger.debug(`[DisplayPlayerManager] Initializing for display ${displayId}`);
        const playerManager = this.playerManagerFactory.createForDisplay(displayId);
        this.playerManagers.set(displayId, playerManager);
        await playerManager.initialize();
        if (this.playerManagers.size > 2) {
            this.logger.log(this.playerManagers.size === 3 ? LogLevel.NOTICE : LogLevel.WARNING, `[DisplayPlayerManager] Large amount of player managers initialized`, { displayId, playerManagers: this.playerManagers.size });
        }
        return playerManager;
    }
    getForDisplay(displayId) {
        const playerManager = this.playerManagers.get(displayId);
        if (!playerManager) {
            this.logger.error(`[DisplayPlayerManager] Player manager for display ${displayId} not found`);
            return null;
        }
        return playerManager;
    }
    async changeDisplay(displayId, newDisplayId) {
        const playerManager = this.playerManagers.get(displayId);
        if (!playerManager) {
            this.logger.error(`[DisplayPlayerManager] Player manager for display ${displayId} not found`, {
                requestedDisplayId: displayId,
                newDisplayId,
                knownDisplayIds: Array.from(this.playerManagers.keys()),
                managerCount: this.playerManagers.size,
            });
            return false;
        }
        if (this.playerManagers.has(newDisplayId)) {
            this.logger.notice(`[DisplayPlayerManager] Player manager for display ${newDisplayId} already exists, deleting it`);
            await this.destroyForDisplay(newDisplayId);
        }
        this.playerManagers.set(newDisplayId, playerManager);
        this.playerManagers.delete(displayId);
        return true;
    }
    hasForDisplay(displayId) {
        return this.playerManagers.has(displayId);
    }
    async getOrInitializeForDisplay(displayId) {
        let playerManager = null;
        if (this.playerManagers.has(displayId)) {
            playerManager = this.getForDisplay(displayId);
        }
        if (!playerManager) {
            playerManager = await this.initializeForDisplay(displayId);
        }
        return playerManager;
    }
    async destroyForDisplay(displayId) {
        const playerManager = this.playerManagers.get(displayId);
        if (!playerManager) {
            this.logger.error(`[DisplayPlayerManager] Player manager for display ${displayId} not found`);
            return;
        }
        await playerManager.destroy();
        this.playerManagers.delete(displayId);
        if (this.onDestroyCallback) {
            this.onDestroyCallback(displayId);
        }
        this.logger.debug(`[DisplayPlayerManager] Destroyed player manager for display ${displayId}`);
    }
    async destroy() {
        for (const displayId of this.playerManagers.keys()) {
            const playerManager = this.playerManagers.get(displayId);
            if (!playerManager) {
                continue;
            }
            await playerManager.destroy();
            if (this.onDestroyCallback) {
                this.onDestroyCallback(displayId);
            }
        }
        this.playerManagers.clear();
        this.logger.debug(`[DisplayPlayerManager] Destroyed all player managers`);
    }
    onDestroy(callback) {
        this.onDestroyCallback = callback;
    }
}
//# sourceMappingURL=DisplayPlayerManager.js.map